import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import { FaDollarSign } from "react-icons/fa";
import { IoSettingsOutline } from "react-icons/io5";
import { toast } from "react-hot-toast";
import apiRequests from "../axios/config/config";

export default function ChartComponent() {
  const [timeRange, setTimeRange] = useState("week");
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(false);

  async function getChartData() {
    try {
      setLoading(true);

      const response = await apiRequests.get(
        `/seller/v1/get-chart-analytics?type=${timeRange}`,
      );

      setChartData(response.data.data.chartData || []);
    } catch (err) {
      console.log(err);
      toast.error(
        err?.response?.data?.en_message || "Failed to load chart data",
      );
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getChartData();
  }, [timeRange]);

  const BAR_WIDTH = 115;
  const chartWidth = chartData.length * BAR_WIDTH;

  return (
    <div className="col-span-9 w-full bg-[#efe5df] rounded-[30px] p-6 font-inter shadow-sm flex flex-col relative md:col-span-1 md:w-full">
      <div className="md:flex-row justify-between items-start md:items-center sm:flex-col">
        <div className="flex items-center gap-2">
          <FaDollarSign className="w-6 h-6 " />
          <h2 className="text-3xl font-bold ">Total sells</h2>
        </div>

        <div className="flex items-center justify-between gap-4 md:flex-row md:items-center sm:flex-col">
          <div className="flex flex-row items-center gap-2 pt-5 text-[#1f1b18] ">
            <IoSettingsOutline className="h-6 w-6" />
            <p>Date:</p>
            <p>13 december-20 december</p>
          </div>

          <div className="bg-white rounded-xl p-1 flex shadow-sm ">
            <button
              onClick={() => setTimeRange("day")}
              className={`px-6 py-1 rounded-lg text-lg font-medium transition-all duration-300 ${
                timeRange === "day"
                  ? "bg-[#efe5df] text-[#1f1b18] shadow-inner"
                  : "bg-transparent text-gray-400 hover:text-gray-600"
              }`}
            >
              daily
            </button>
            <button
              onClick={() => setTimeRange("week")}
              className={`px-6 py-1 rounded-lg text-lg font-medium transition-all duration-300 ${
                timeRange === "week"
                  ? "bg-[#efe5df] text-[#1f1b18] shadow-inner"
                  : "bg-transparent text-gray-400 hover:text-gray-600"
              }`}
            >
              weekly
            </button>
            <button
              onClick={() => setTimeRange("month")}
              className={`px-6 py-1 rounded-lg text-lg font-medium transition-all duration-300 ${
                timeRange === "month"
                  ? "bg-[#efe5df] text-[#1f1b18] shadow-inner"
                  : "bg-transparent text-gray-400 hover:text-gray-600"
              }`}
            >
              monthly
            </button>
          </div>
        </div>
      </div>
      <div className="w-full min-h-[300px] overflow-x-auto ">
        <div style={{ width: chartWidth, height: "100%" }}>
          <BarChart
            width={chartWidth}
            height={250}
            data={chartData}
            margin={{ top: 20, right: 0, left: 0, bottom: 5 }}
            barSize={50}
          >
            <CartesianGrid
              strokeDasharray="3 3"
              vertical={true}
              stroke="#ccc"
            />
            <XAxis
              dataKey="day"
              axisLine={true}
              tickLine={false}
              tick={{ fill: "#5c4a40", fontSize: 14 }}
              dy={10}
            />
            <Tooltip
              cursor={{ fill: "transparent" }}
              contentStyle={{
                backgroundColor: "#fff",
                borderRadius: "10px",
                border: "none",
              }}
            />
            <Bar dataKey="order" fill="#031d2e" radius={[30, 30, 0, 0]}></Bar>
          </BarChart>
        </div>
      </div>
      <div className="mt-4 flex justify-center">
        <span className="px-3 py-1 rounded-full bg-white text-xs text-[#5c4a40] shadow-sm">
          Hover on bars to view details
        </span>
      </div>{" "}
      <div className="flex justify-center items-center gap-2 mt-4 text-sm text-[#5c4a40]">
        <div className="w-3 h-3 bg-[#031d2e] rounded-t-lg"></div>
        <span>total sells numbers / amounts</span>
      </div>
    </div>
  );
}